import { faCaretUp, faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import { cn } from 'src/utils/cn';

type Props = {
  isOpen: boolean;
  showError?: boolean;
  disabled?: boolean;
  'data-testid'?: string;
};

export const SelectToggleIcon: FC<Props> = ({
  isOpen,
  showError,
  disabled,
  'data-testid': dataTestId,
}) => {
  return (
    <div
      data-testid={dataTestId}
      className={cn(
        `
          text-foreground-surface-default
          legacy:text-legacy-brand
        `,
        showError &&
          `
            border-border-support-error-subdued
            bg-background-support-error-minimal text-foreground-support-error
            legacy:border-legacy-error legacy:bg-legacy-error-lighter
            legacy:text-legacy-error
          `,
        disabled &&
          `
            cursor-not-allowed border-border-surface-disabled
            bg-background-surface-disabled text-foreground-surface-disabled
            legacy:border-legacy-inactive legacy:bg-legacy-inactive-lighter
            legacy:text-legacy-inactive
          `
      )}
    >
      <FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
    </div>
  );
};
